import React from "react";
import { History } from "lucide-react";

const fmt = (n, d = 2) =>
  n?.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });

/**
 * Recent trade history list on the Paper Trading page.
 *
 * Buy/sell pill, symbol, name, quantity, fill price, total, timestamp.
 */
export default function TradesHistory({ trades = [] }) {
  return (
    <section>
      <h2 className="font-heading text-2xl text-[#2A2F2B] mb-4 flex items-center gap-2">
        <History className="w-5 h-5 text-[#6B7068]" strokeWidth={1.5} /> Trade history
      </h2>
      {trades.length === 0 ? (
        <div className="rounded-2xl bg-white border border-[#EAE6E1] p-6 text-sm text-[#6B7068]">
          No trades yet.
        </div>
      ) : (
        <div className="rounded-2xl bg-white border border-[#EAE6E1] overflow-hidden">
          {trades.map((t) => (
            <div
              key={t.id}
              data-testid={`trade-row-${t.id}`}
              className="flex items-center gap-4 px-6 py-3 border-b border-[#EAE6E1] last:border-0 hover:bg-[#F9F8F6] transition-soft"
            >
              <div
                className="text-[10px] uppercase tracking-[0.2em] font-semibold px-2 py-1 rounded-full"
                style={{
                  backgroundColor: t.side === "buy" ? "#5C8D7315" : "#C66B5915",
                  color: t.side === "buy" ? "#5C8D73" : "#C66B59",
                }}
              >
                {t.side}
              </div>
              <div className="font-mono-ticker font-semibold text-[#2A2F2B] w-16">{t.symbol}</div>
              <div className="hidden sm:block text-sm text-[#6B7068] flex-1 truncate">{t.name}</div>
              <div className="font-mono-ticker text-sm text-[#2A2F2B]">{t.quantity.toFixed(4)}</div>
              <div className="hidden md:block font-mono-ticker text-sm text-[#6B7068] w-24 text-right">@ ${fmt(t.price)}</div>
              <div className="font-mono-ticker text-sm text-[#2A2F2B] w-24 text-right">${fmt(t.total)}</div>
              <div className="hidden lg:block text-xs text-[#6B7068] w-32 text-right font-mono-ticker">
                {new Date(t.created_at).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
